import React from "react"
import Grid from "./grid"
import { Title, Description, HeroContainer } from "./hero.style"
import Breakpoints from "./breakpoints"
import { FluidObject } from "gatsby-image"
import { FlattenSimpleInterpolation } from "styled-components"
import { IBreakpointImageVariants } from "../../design-system/atoms/breakpoint-image"
import { graphql } from "gatsby"

interface IHero {
  title?: string
  description?: string
  descriptionStyle?: FlattenSimpleInterpolation
  overlayStyle?: FlattenSimpleInterpolation
  children?: React.ReactNode
}

interface IHeroImageVariants extends IHero {
  sizes: IBreakpointImageVariants
  fluid?: never
}

interface IHeroFluidImage extends IHero {
  fluid: FluidObject
  sizes?: never
}

const Hero = ({
  title,
  description,
  descriptionStyle,
  overlayStyle,
  sizes,
  fluid,
  children,
}: IHeroImageVariants | IHeroFluidImage) => {
  let image: FluidObject[] | FluidObject = sizes ? [sizes.sm] : fluid

  if (sizes.md) {
    // @ts-ignore -- if 'sizes' then image is an array
    image.push({
      ...sizes.md,
      media: `(min-width: ${Breakpoints.md})`,
    })
  }
  if (sizes.lg) {
    // @ts-ignore
    image.push({
      ...sizes.lg,
      media: `(min-width: ${Breakpoints.lg})`,
    })
  }

  return (
    <HeroContainer fluid={image} critical loading="eager" fadeIn={false}>
      <Grid overlayStyle={overlayStyle}>
        {title && <Title>{title}</Title>}
        {description && (
          <Description styleModifier={descriptionStyle}>
            {description}
          </Description>
        )}
        {children}
      </Grid>
    </HeroContainer>
  )
}

export const HeroFragment = graphql`
  fragment Hero on ContentfulWebsitePage {
    hero {
      title
      body {
        raw
      }
      backgroundImage {
        mobile {
          fluid(maxWidth: 768) {
            ...GatsbyContentfulFluid
          }
        }
        tablet {
          fluid(maxWidth: 1440) {
            ...GatsbyContentfulFluid
          }
        }
        desktop {
          fluid(maxWidth: 1920) {
            ...GatsbyContentfulFluid
          }
        }
      }
      overlayColour {
        hex
      }
    }
  }
`
export default Hero
